import axios from 'axios';
import {
	bind,
	compose,
	prop,
} from 'ramda';

const instance = axios.create()

instance.interceptors.response.use(config => config, handleErrorAndReject)

const printError = bind(console.error, console);
const reject = bind(Promise.reject, Promise);
const handleErrorAndReject = compose(
	reject,
	printError
);

export default instance
